import { getHttp } from '@speechki-frontend/shared/axios/httpRef';

const state = {
    limits: [],
    contentTypes: []
};

const getters = {
    freeLimit: state => {
        if (!state.limits.length) return undefined;
        return state.limits.find(limit => limit.name.toLowerCase() === 'free');
    },
    limitsByCurrency: state => {
        let newLimits = {
            RUB: [],
            USD: []
        };

        state.limits.forEach(lim => {
            if (lim.name === 'free') {
                newLimits.USD.push(lim);
                newLimits.RUB.push(lim);
                return;
            }

            if (lim.params.calculate_rule !== 'symbols') return;

            newLimits[lim.currency].push(lim);
        });

        return newLimits;
    },
    bookContentTypeId: state => {
        const model = state.contentTypes.find(type => type.model === 'book');
        if (!model) {
            return null;
        }
        return model.id;
    },
    findLimitBySpeaker: state => speakerId => {
        let limit = state.limits.find(lim => {
            let limitSpeakerIds = lim.speakers.map(speaker => speaker.id);

            if (limitSpeakerIds.includes(speakerId)) {
                return true;
            }

            return false;
        });

        return limit || null;
    }
};

const mutations = {
    SET_LIMITS(state, limits) {
        state.limits = limits;
    },
    SET_CONTENT_TYPES(state, types) {
        state.contentTypes = types;
    }
};

const actions = {
    async fetchLimits({ commit }, { currency = '' } = {}) {
        try {
            const params = {
                ordering: 'price'
            };

            if (currency) {
                params.currency = currency;
            }

            const { results } = await getHttp().get('/api/v1/limits/', { params });
            commit('SET_LIMITS', results);
        } catch (error) {
            console.log(error);
        }
    },
    async fetchContentTypes({ commit }) {
        try {
            const types = await getHttp().get('/api/v1/content_types/?app_label=book');
            commit('SET_CONTENT_TYPES', types);
        } catch (error) {
            console.log(error);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
